import '../polyfill';

/**
 * cardClick
 * When routing cards are clicked
 *
 * @param {*} elem
 */
const cardClick = elem => {
	const card = elem;
	const anchor = card.getElementsByTagName('a');
	const href = anchor[0].getAttribute('href');
	const target = anchor[0].getAttribute('target');

	if (anchor) {
		if (target === '_blank') {
			window.open(href);
			return false;
		} else {
			window.location = href;
		}
	}
};

// Routing Cards
const cardList = document.querySelectorAll('.oda-block .oda-block--card');
if (cardList) {
	Array.from(cardList).map(card =>
		card.addEventListener('click', () => cardClick(card))
	);
}
